import React from 'react';

import { Link } from '../../../components/elements';
import { groupGlossaryByLetters } from './GlossaryList.helpers';
import Styles from './GlossaryList.module.scss';
import { GlossaryListProps } from './GlossaryList.types';

const GlossaryList = ({ glossaryList, basePath }: GlossaryListProps) => {
  const groupedList: { [key: string]: { translations: { title: string }[]; slug: string }[] } =
    groupGlossaryByLetters(glossaryList);

  return (
    <div className={Styles.wrapper}>
      {Object.keys(groupedList).map((key) => (
        <div key={key} className={Styles.group}>
          <div className={Styles.header}>
            <h2 className={Styles.headerText}>{key}</h2>
          </div>
          <ul className={Styles.list}>
            {groupedList[key].map(({ translations, slug }, index) => (
              <li key={slug + index} className={Styles.listItem}>
                <Link
                  variant={['underlined', 'dark']}
                  to={`${basePath}/${slug}`}
                  title={translations[0].title}
                >
                  {translations[0].title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default GlossaryList;
